import { ThemeProvider } from '@alterrego/core-ui';
import { BrandingProvider } from '@alterrego/module-branding';
import tenantConfig from '../tenant.config.json';
import type { TenantConfig } from '@alterrego/core-config';
import { useRoute, matchMaisonId } from './lib/router';
import { HomeScreen } from './screens/HomeScreen';
import { MaisonsScreen } from './screens/MaisonsScreen';
import { MaisonDetailScreen } from './screens/MaisonDetailScreen';
import { GiftCardScreen } from './screens/GiftCardScreen';
import { ComingSoonScreen } from './screens/ComingSoonScreen';

const config = tenantConfig as TenantConfig;

// V0 : portail anonyme (anonymous-first). Routeur hash maison/rubriques, pas de
// login. Le compte (carte cadeau / fidélité) viendra plus tard.
function Router() {
  const path = useRoute();
  const maisonId = matchMaisonId(path);
  if (maisonId) return <MaisonDetailScreen id={maisonId} />;
  if (path === '/maisons') return <MaisonsScreen />;
  if (path === '/carte-cadeau') return <GiftCardScreen />;
  if (path === '/univers') return <ComingSoonScreen titleKey="tile_universe" />;
  return <HomeScreen />;
}

export default function App() {
  // BrandingProvider gère la résolution du tenant (sous-domaine → sous-tenants
  // bocuse-abbaye/… à terme), le titre/méta PWA et les feature flags. Les
  // couleurs restent pilotées par le ThemeProvider de core-ui (tenant.config.json)
  // → aucune régression visuelle : applyTheme={false} délègue le thème.
  return (
    <BrandingProvider fallbackTenant="maisons-bocuse" applyTheme={false}>
      <ThemeProvider config={config}>
        <Router />
      </ThemeProvider>
    </BrandingProvider>
  );
}
